import uploadApi from '@Apis/upload.api';
import { AssetFieldsResolvedResponse } from '@Types/asset.types';

export const getAssetFieldsApi = () => {
	const address = '/mapping/assets/wwPipe.yaml';
	return uploadApi.get<AssetFieldsResolvedResponse>(address);
};
